// extracted by mini-css-extract-plugin
export var editInput = "_jv-0";
export var editInputCompact = "_jv-2";
export var editInputLarge = "_jv-1";
export var editInputSmall = "_jv-3";